import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentPositionMember } from '@core/tellent-positions-types';
import { resolveMemberFullName } from '@core/tellent-util';
import {
  AvatarComponent,
  ButtonComponent,
  HeadingComponent,
  IconComponent,
  TruncateComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-position-details-member-item',
  templateUrl: './position-details-member-item.component.html',
  styleUrls: ['./position-details-member-item.component.less'],
  imports: [
    AvatarComponent,
    ButtonComponent,
    HeadingComponent,
    IconComponent,
    TranslatePipe,
    TruncateComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PositionDetailsMemberItemComponent {
  public readonly member = input.required<TellentPositionMember>();
  public readonly canUnassign = input<boolean>(false);
  public readonly canViewHistory = input<boolean>(false);

  public readonly viewMember = output<string>();
  public readonly viewHistory = output<string>();
  public readonly unassignMember = output<TellentPositionMember>();

  public readonly memberFullName = computed(() => resolveMemberFullName(this.member()));
}
